import { render, staticRenderFns } from "./PcHome.vue?vue&type=template&id=608e024d&scoped=true"
import script from "./PcHome.vue?vue&type=script&lang=js"
export * from "./PcHome.vue?vue&type=script&lang=js"
import style0 from "./PcHome.vue?vue&type=style&index=0&id=608e024d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e024d",
  null
  
)

export default component.exports